<template>
  <div>
    <v-row justify="center">
      <div class="text_white">
        To provide financial freedom for gamers, eSports fans, and investors.
      </div>
    </v-row>

    <v-row justify="center" align="center" style="margin-top:75px">
      <v-col cols="12" md="3" class="d-flex justify-center align-center flex-column">
        <v-img contain :width="$vuetify.breakpoint.mobile ? 165 : 322" max-width="322" max-height="269" :src="require('@/assets/img/n_img1.png')"></v-img>
        <div class="of">
          <div class="text_ww">
            Make everyday gaming <span>profitable and entertaining.</span>
          </div>
        </div>

        <div class="align-self-center">
          <v-img contain :width="$vuetify.breakpoint.mobile ? 60 : 120" max-width="120" max-height="112" :src="require('@/assets/img/controller.png')"></v-img>
        </div>
      </v-col>

      <v-col cols="12" md="3" class="d-flex justify-center align-center flex-column" style="margin: 0px 74px;">
        <v-img contain :width="$vuetify.breakpoint.mobile ? 165 : 322" max-width="322" max-height="269" :src="require('@/assets/img/n_img2.png')"></v-img>

        <div class="of">
          <div class="text_ww">
            Bringing competitors and audience <span>together.</span>
          </div>
        </div>

        <div class="align-self-center">
          <v-img contain :width="$vuetify.breakpoint.mobile ? 60 : 120" max-width="120" max-height="112" :src="require('@/assets/img/bridge.png')"></v-img>
        </div>

      </v-col>
      <v-col cols="12" md="3"  class="d-flex justify-center align-center flex-column">
        <v-img contain :width="$vuetify.breakpoint.mobile ? 165 : 322" max-width="322" max-height="269" :src="require('@/assets/img/n_img3.png')"></v-img>
        
        <div class="of">
          <div class="text_ww text-center justify-center">
            Create a universal <span>betting solution</span> for eSports.
          </div>
        </div>

        <div class="align-self-center">
          <v-img contain :width="$vuetify.breakpoint.mobile ? 60 : 120" max-width="120" max-height="112" :src="require('@/assets/img/graph.png')"></v-img>
        </div>
      </v-col>
    </v-row>
    
  </div>
</template>

<script>
export default {
  name: "FinancialFreedom",
};
</script>

<style lang="scss" scoped>
.of {
  margin-top: 25px;

  @media (min-width: 992px) {
    margin-top: 60px;
  }
}

.text_white {
  font-family: Orbitron;
  font-style: normal;
  font-weight: bold;
  font-size: 40px;
  line-height: 66px;

  width: 60%;

  text-align: center;

  color: #FFFFFF;
}

.text_ww {
  width: 211px;
  height: 122px;
  font-family: Orbitron;
  font-style: normal;
  font-weight: 500;
  font-size: 19px;
  line-height: 33px;

  text-align: center;

  color: #FFFFFF;

  span {
    color: #ECA93E;
  }
}
</style>